import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';

function createLoader() {
  const loader = new GLTFLoader();
  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath('libs/draco/gltf/');
  loader.setDRACOLoader(dracoLoader);
  return loader;
}

function loadModel(loader, path) {
  return new Promise((resolve, reject) => {
    loader.load(path, resolve, undefined, reject);
  });
}

function applyEncoding(root, encoding) {
  root.traverse((object) => {
    if (object.material && object.material.map) {
      object.material.map.encoding = encoding;
    }
  });
}

function applyEnvMapIntensity(root, value) {
  root.traverse((object) => {
    if (object.material) {
      object.material.envMapIntensity = value;
    }
  });
}

function applyEnvMap(root, texture) {
  root.traverse((object) => {
    if (object.material) {
      object.material.envMap = texture;
    }
  });
}

export function createModelLoader(basePath, options = {}) {
  const loader = createLoader();
  loader.setPath(basePath);

  const partList = [];

  const { encoding, envMapIntensity, envMap, fileExt = 'gltf' } = options;

  async function loadPart(options) {
    let name,
      handler,
      subPath = '';
    if (typeof options === 'string') {
      name = options;
    } else {
      ({ name, handler, subPath = '' } = options);
    }
    const names = name instanceof Array ? name : [name];
    const result = await Promise.all(
      names.map(async (name) => {
        const resourcePath = `${basePath}${subPath}${name}/`;
        loader.setResourcePath(resourcePath);
        const gltf = await loadModel(loader, `${subPath}${name}/${name}.${fileExt}`);
        encoding && applyEncoding(gltf.scene, encoding);
        Number.isFinite(envMapIntensity) && applyEnvMapIntensity(gltf.scene, envMapIntensity);
        envMap && applyEnvMap(gltf.scene, envMap);
        handler && handler(gltf, { name });
        return gltf;
      })
    );
    return names === name ? result : result[0];
  }

  function loadAll() {
    return Promise.all(partList.map(loadPart));
  }

  function addHandler(options, fn) {
    if (typeof options === 'string') {
      options = {
        name: options,
      };
    }
    partList.push({ ...options, handler: fn });
  }

  return {
    loadAll,
    addHandler,
    loadPart,
  };
}
